import React, { useReducer } from 'react'

import { styled } from 'nativewind'

import { useEffectAfterMount } from '../hooks'
import { Stack } from '../layout'
import { Option } from './Option'
import { Radio } from './Radio'
import { reducer } from './Reducer'
import { SelectContext } from './SelectContext'
import { Props } from './interfaces'

const SelectContainer = styled(
  Stack,
  'justify-center items-center self-center w-full'
)

export function Select({
  eventValueKey = 'select',
  eventItemName = 'itemName',
  mode = 'single',
  value,
  ...props
}: Props) {
  const [state, dispatch] = useReducer(reducer, {
    selectedItem: value || null,
    selectedItemDisplayText: null,
    mode: mode,
  })

  useEffectAfterMount(() => {
    props.onChange(state.selectedItem, state.selectedItemDisplayText)
  }, [state.selectedItem])

  return (
    <SelectContext.Provider value={{ state, dispatch }}>
      <SelectContainer>{props.children}</SelectContainer>
    </SelectContext.Provider>
  )
}

Select.Option = Option
Select.Radio = Radio
